import { cachingService, LocalLookupService } from "@ofqual/portal-core/core/dataAccess";
import { API_HOST_USERS, API_HOST_SOCV2, API_HOST_ORGS, API_HOST_REFDATA } from "../config";
import exampleLookups from "./json/exampleLookups.json";
import { SocService } from "./SocService";
import socStatus from "./json/socStatus.json"
import { AwardingOrgService } from "./AwardingOrgService";
import { UserService } from "./UsersService";
import closingStatusLookups from './json/closingStatusLookups.json';
import closingStatusRationaleLookups from './json/closingStatusRationaleLookups.json';
import complianceDisagreementLookups from "./json/complianceDisagreementLookups.json";
import eventTypesLookups from "./json/eventTypesLookups.json"
import noteTypesLookups from "./json/noteTypesLookups.json"
import followupLeadLookups from "./json/followupLeadLookups.json";

import followupLookups from "./json/followupLookups.json";
import followupStatusLookups from "./json/followupStatusLookups.json";
import ragRatingLookups from "./json/ragRatingLookups.json";
import regulatoryComplianceLookups from "./json/regulatoryComplianceClosureStatusLookups.json";
import { GeneralConditionsService } from "./GeneralConditionsService";
import { QualificationConditionsService } from "./QualificationConditionsService";
import { SubjectConditionsService } from "./SubjectConditionsService";

export const exampleLookupService = new LocalLookupService(exampleLookups);

export const socService = new SocService(API_HOST_SOCV2);
export const socStatusService = new LocalLookupService(socStatus);
export const aoService = new AwardingOrgService(API_HOST_ORGS);
export const cachingAoService = cachingService(aoService);
export const usersService = new UserService(API_HOST_USERS);


export const closingStatusRationaleService = new LocalLookupService(closingStatusRationaleLookups);
export const closingStatusService = new LocalLookupService(closingStatusLookups);
export const complianceDisagreementService = new LocalLookupService(complianceDisagreementLookups);
export const eventTypesService = new LocalLookupService(eventTypesLookups);
export const noteTypesService = new LocalLookupService(noteTypesLookups);
export const followupLeadService = new LocalLookupService(followupLeadLookups);
export const followupService = new LocalLookupService(followupLookups);
export const followupStatusService = new LocalLookupService(followupStatusLookups);
export const ragRatingService = new LocalLookupService(ragRatingLookups);
export const regulatoryComplianceService = new LocalLookupService(regulatoryComplianceLookups);

export const generalConditionsService = new GeneralConditionsService(
    API_HOST_REFDATA
  );
  export const qualificationConditionsService = new QualificationConditionsService(
    API_HOST_REFDATA
  );
  export const subjectConditionsService = new SubjectConditionsService(
    API_HOST_REFDATA
  );